import {
  PUBLIC_HOLIDAY_DETAIL_TYPE,
  PUBLIC_HOLIDAY_LIST_PARAMS_REQUEST,
} from 'models/public-holiday';

export const GET_PUBLIC_HOLIDAY_LIST_REQUEST: string =
  'GET_PUBLIC_HOLIDAY_LIST_REQUEST';
export const DELETE_PUBLIC_HOLIDAY_REQUEST: string =
  'DELETE_PUBLIC_HOLIDAY_REQUEST';
export const UPDATE_PUBLIC_HOLIDAY_LIST_REQUEST: string =
  'UPDATE_PUBLIC_HOLIDAY_LIST_REQUEST';
export const CREATE_PUBLIC_HOLIDAY_LIST_REQUEST: string =
  'CREATE_PUBLIC_HOLIDAY_LIST_REQUEST';
export const GET_PUBLIC_HOLIDAY_DETAIL_REQUEST: string =
  'GET_PUBLIC_HOLIDAY_DETAIL_REQUEST';

export const getPublicHolidayListRequest = (
  params?: PUBLIC_HOLIDAY_LIST_PARAMS_REQUEST | null
) => {
  return {
    type: GET_PUBLIC_HOLIDAY_LIST_REQUEST,
    payload: { params },
  };
};

export const getPublicHolidayDetailRequest = (
  params?: PUBLIC_HOLIDAY_DETAIL_TYPE | null
) => {
  return {
    type: GET_PUBLIC_HOLIDAY_DETAIL_REQUEST,
    payload: { params },
  };
};

export const updatePublicHolidayListRequest = (
  params?: PUBLIC_HOLIDAY_LIST_PARAMS_REQUEST | null
) => {
  return {
    type: UPDATE_PUBLIC_HOLIDAY_LIST_REQUEST,
    payload: { params },
  };
};

export const createPublicHolidayListRequest = (
  params?: PUBLIC_HOLIDAY_LIST_PARAMS_REQUEST | null
) => {
  return {
    type: GET_PUBLIC_HOLIDAY_LIST_REQUEST,
    payload: { params },
  };
};

export const deletePublicHolidayAction = (payload: {
  id: string;
  onSuccess?: () => void;
}) => {
  return {
    type: DELETE_PUBLIC_HOLIDAY_REQUEST,
    payload,
  };
};
